import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { rowsFromApproveResponse, showCsSendResult } from '../../../../components/cs-send-result';

const POST_APPROVE_CLAIM = `/warranty/abm/api/v2/admin/claims/update/status/approve-list`;

export const useApproveClaim = ({ modal, onSuccessCallback }) =>
  useMutation({
    mutationFn: async ({ claimIdList }) => {
      const payload = {
        claimIdList,
      };
      const response = await POST(POST_APPROVE_CLAIM, payload);
      return response;
    },

    onSuccess: (response) => {
      if (onSuccessCallback) onSuccessCallback();
      showCsSendResult(modal, {
        title: 'อนุมัติเคลมสำเร็จ ผลการส่ง CS',
        rows: rowsFromApproveResponse(response),
      });
    },
  });
